const isUSCardPaymentData = (card) => card.usCard;
const isEcheckPaymentData = (paymentData) => 'routingNumber' in paymentData;

/**
 * Generated bundle index. Do not edit.
 */

export { isEcheckPaymentData, isUSCardPaymentData };
